const comparisonData = [
  {
    name: 'Hipobuy\nSpreadsheet',
    icon: 'ri-star-line',
    automation: 5,
    facilite: 5,
    prix: '€',
    ia: 'Oui',
    highlight: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20dashboard%20interface%20with%20colorful%20data%20charts%20and%20analytics%20widgets%20on%20a%20clean%20screen%2C%20warm%20terracotta%20accent%20colors%2C%20soft%20gradient%20background%2C%20sleek%20UI%20design%2C%20abstract%20data%20visualization%2C%20professional%20SaaS%20aesthetic&width=400&height=300&seq=comp-img-hipobuy-dash&orientation=landscape',
  },
  {
    name: 'Excel',
    icon: 'ri-microsoft-line',
    automation: 2,
    facilite: 3,
    prix: '€€',
    ia: 'Non',
    highlight: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20spreadsheet%20interface%20with%20green%20grid%20lines%20and%20white%20cells%20on%20a%20desktop%20monitor%2C%20office%20setting%20with%20warm%20ambient%20light%2C%20classic%20Microsoft%20style%2C%20corporate%20environment%2C%20clean%20workspace%20with%20coffee%20cup&width=400&height=300&seq=comp-img-excel-grid&orientation=landscape',
  },
  {
    name: 'Google\nSheets',
    icon: 'ri-google-line',
    automation: 3,
    facilite: 4,
    prix: '€',
    ia: 'Limité',
    highlight: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Browser%20window%20showing%20colorful%20Google%20Sheets%20spreadsheet%20with%20collaborative%20editing%20cursors%2C%20modern%20web%20application%20on%20a%20laptop%20screen%2C%20bright%20clean%20interface%2C%20co-working%20space%20background%20with%20natural%20light%2C%20productivity%20scene&width=400&height=300&seq=comp-img-gsheets-web&orientation=landscape',
  },
  {
    name: 'Airtable',
    icon: 'ri-database-2-line',
    automation: 4,
    facilite: 3,
    prix: '€€',
    ia: 'Oui',
    highlight: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20database%20interface%20showing%20kanban%20cards%20and%20grid%20view%20on%20a%20laptop%20display%2C%20modern%20no-code%20platform%2C%20creative%20studio%20workspace%20with%20plants%20and%20notebook%2C%20warm%20natural%20lighting%2C%20organized%20minimal%20desk%20setup&width=400&height=300&seq=comp-img-airtable-db&orientation=landscape',
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <i
          key={i}
          className={`ri-star-fill w-3 h-3 flex items-center justify-center text-xs ${
            i <= count ? 'text-amber-400' : 'text-foreground-200'
          }`}
        ></i>
      ))}
    </div>
  );
}

export default function ComparisonTable() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full border border-primary-200 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
            Comparaison
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight mb-4">
            Hipobuy Spreadsheet<br />vs concurrents
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Découvrez pourquoi Hipobuy Spreadsheet surpasse les outils traditionnels en automatisation, intelligence artificielle et facilité d&apos;utilisation.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comparisonData.map((tool) => (
            <div
              key={tool.name}
              className={`rounded-2xl overflow-hidden transition-all duration-300 group cursor-pointer ${
                tool.highlight
                  ? 'bg-primary-500 text-background-50 shadow-lg hover:shadow-xl hover:scale-[1.03]'
                  : 'bg-background-100 border border-background-200 hover:border-primary-200 hover:shadow-md'
              }`}
            >
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={tool.imageUrl}
                  alt={tool.name.replace('\n', ' ')}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-5 md:p-6">
                {/* Icon + Name */}
                <div className="flex items-center gap-3 mb-4">
                  <div
                    className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                      tool.highlight
                        ? 'bg-background-50/20'
                        : 'bg-background-200'
                    }`}
                  >
                    <i
                      className={`${tool.icon} w-5 h-5 flex items-center justify-center text-lg ${
                        tool.highlight ? 'text-background-50' : 'text-foreground-700'
                      }`}
                    ></i>
                  </div>
                  <h3
                    className={`text-base font-heading leading-tight whitespace-pre-line ${
                      tool.highlight ? 'text-background-50' : 'text-foreground-950'
                    }`}
                  >
                    {tool.name}
                  </h3>
                </div>

                {/* Specs */}
                <div className="space-y-3 mb-5">
                  <div className="flex items-center justify-between">
                    <span
                      className={`text-sm ${
                        tool.highlight ? 'text-background-50/80' : 'text-foreground-600'
                      }`}
                    >
                      Automatisation
                    </span>
                    <Stars count={tool.automation} />
                  </div>
                  <div className="flex items-center justify-between">
                    <span
                      className={`text-sm ${
                        tool.highlight ? 'text-background-50/80' : 'text-foreground-600'
                      }`}
                    >
                      Facilité
                    </span>
                    <Stars count={tool.facilite} />
                  </div>
                  <div className="flex items-center justify-between">
                    <span
                      className={`text-sm ${
                        tool.highlight ? 'text-background-50/80' : 'text-foreground-600'
                      }`}
                    >
                      Prix
                    </span>
                    <span
                      className={`text-sm font-semibold ${
                        tool.highlight ? 'text-background-50' : 'text-foreground-900'
                      }`}
                    >
                      {tool.prix}
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span
                      className={`text-sm ${
                        tool.highlight ? 'text-background-50/80' : 'text-foreground-600'
                      }`}
                    >
                      IA intégrée
                    </span>
                    <span
                      className={`text-sm font-semibold ${
                        tool.highlight ? 'text-background-50' : 'text-foreground-900'
                      }`}
                    >
                      {tool.ia}
                    </span>
                  </div>
                </div>

                {/* Button */}
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className={`inline-flex items-center gap-2 text-sm font-medium transition-colors whitespace-nowrap ${
                    tool.highlight
                      ? 'text-background-50 hover:text-background-100'
                      : 'text-primary-600 hover:text-primary-700'
                  }`}
                >
                  Voir détails
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}